import { render, staticRenderFns } from "./mvHklrPaymentTransfer.vue?vue&type=template&id=6786a296"
import script from "./mvHklrPaymentTransfer.vue?vue&type=script&lang=js"
export * from "./mvHklrPaymentTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports